// @flow
import React from 'react';
import {Field, reduxForm} from 'redux-form';
import TextAreaFormInput from '../TextAreaFormInput/TextAreaFormInput';
import DecimalFormInput from '../DecimalFormInput/DecimalFormInput';
import BasicFormInput from '../BasicFormInput/BasicFormInput';
import SelectFormInput from '../SelectFormInput/SelectFormInput';
import {addVAT, removeVAT} from '../../helpers/priceHelpers';
import FileDropzone from '../../components/FileDropzone/FileDropzone';

export type Props = {
  showRoomTypes: Boolean,
  onUserChange: Function,
  customRowFiles: Object,
  suppliers: any[],
  productTypes: any[],
  workerTypes: any[],
  roomTypes: any[],
  rooms: any[],
  customRowFileUploads: Object,
  onUploadFile: Function,
  onFileUploadAbort: Function,
  onRemoveFile: Function,
};

const CustomRowForm = ({
  showRoomTypes,
  customRowFiles,
  suppliers,
  productTypes,
  workerTypes,
  roomTypes,
  rooms,
  customRowFileUploads,
  onUploadFile,
  onFileUploadAbort,
  onRemoveFile,
  onUserChange,
}: Props) => (
  <div className="CustomRowForm">
    <div className="row">
      <div className="small-6 column">
        <Field
          name="name"
          label="Namn"
          component={BasicFormInput}
          onChange={onUserChange}
          type="text" />
        <Field
          name="productTypeId"
          label="Produkttyp"
          normalize={value => value ? value.id : null}
          component={SelectFormInput}
          onChange={onUserChange}
          valueKey="id"
          labelKey="name"
          options={productTypes} />
        <Field
          name="workerTypes"
          label="Yrkeskategorier"
          component={SelectFormInput}
          onChange={onUserChange}
          valueKey="id"
          labelKey="name"
          options={workerTypes}
          multi={true} />
        { showRoomTypes ?
          <Field
            name="roomTypes"
            label="Rumstyper"
            component={SelectFormInput}
            onChange={onUserChange}
            valueKey="id"
            labelKey="name"
            options={roomTypes}
            multi={true} />
          : null
        }
        <Field
          name="room"
          label="Rum"
          component={SelectFormInput}
          onChange={onUserChange}
          valueKey="id"
          labelKey="name"
          options={rooms}
          multi={false} />
        <Field
          name="supplierId"
          label="Leverantör"
          normalize={value => value ? value.id : null}
          component={SelectFormInput}
          onChange={onUserChange}
          valueKey="id"
          labelKey="name"
          options={suppliers} />
        <Field
          name="externalItemNumber"
          label="Externt artikelnummer"
          onChange={onUserChange}
          component={BasicFormInput}
          type="text" />
        <FileDropzone
          label="Image"
          accept="image/png, image/jpg, image/jpeg, image/bmp"
          preview={true}
          file={customRowFiles.image}
          upload={customRowFileUploads.image}
          onUpload={f => onUploadFile('image', f)}
          onUploadAbort={u => onFileUploadAbort(u)}
          onRemove={() => onRemoveFile('image')}
          onChange={onUserChange} />
      </div>
      <div className="small-6 column">
        <Field
          name="externalDescription"
          label="Produktbeskrivning"
          component={TextAreaFormInput}
          onChange={onUserChange} />
        <Field
          name="internalDescription"
          label="Intern beskrivning"
          component={TextAreaFormInput}
          onChange={onUserChange} />
        <Field
          name="quantity"
          label="Antal"
          component={DecimalFormInput}
          onChange={onUserChange} />
        <Field
          name="totalBuyingPrice"
          label="Inköpspris ink. moms (OBS! Ange totalkostnaden för samtliga antal!)"
          component={DecimalFormInput}
          onChange={onUserChange} />
        <Field
          name="totalSellingPrice"
          label="Säljpris ex. moms (OBS! Ange totalkostnaden för samtliga antal!)"
          onChangeTransform={addVAT}
          valueTransform={removeVAT}
          component={DecimalFormInput}
          onChange={onUserChange} />
        <Field
          name="totalSellingPrice"
          label="Säljpris ink. moms (OBS! Ange totalkostnaden för samtliga antal!)"
          component={DecimalFormInput}
          onChange={onUserChange} />
      </div>
    </div>
    <div className="row">
      <div className="small-6 column">

      </div>
      <div className="small-6 column">

      </div>
    </div>
  </div>
);

export default reduxForm({
  form: 'customRow',
  enableReinitialize: true,
})(CustomRowForm);



// WEBPACK FOOTER //
// ./src/components/CustomRowForm/CustomRowForm.js